import React, { useEffect, useMemo, useRef, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import { getTableSortingHeaderIcon } from "helpers/common"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { useLazyGetWpsigningRequestsQuery } from "store/api/wealth-partner/wealth-partners.api"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
  redirection_url: window.location.href,
}

const SigningRequestsWp = () => {
  const [getResults, { isFetching }] = useLazyGetWpsigningRequestsQuery()
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [filters, setFilters] = useState(defaultFilters)
  const { hasPermission } = usePermission()

  //meta title
  document.title = "Signing Requests - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        accessorKey: "formatted_created_at",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Wealth Partner Detail"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={row?.original.wealthPartner?.avatar_url}
            email={row?.original.wealthPartner?.email}
            name={row?.original.wealthPartner?.name}
          />
        ),
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Reference No."),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-number">
            {row?.original.template_type === "TERM_SHEET"
              ? row?.original.icdsRequests?.icds?.unique_code
              : row?.original?.agreement_ref}
          </div>
        ),
      },
      {
        header: "Document Type",
        accessorKey: "template_type",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {row?.original.template_type === "TERM_SHEET" ? (
              <div className="badge approved">
                <span></span> ICD Schedule Terms
              </div>
            ) : (
              <div className="badge counteroffer">
                <span></span> ICD Master Agreement
              </div>
            )}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => (
          <div className="d-flex flex-column align-items-center gap-1 buttons">
            <a href={row.original.doc}>Sign Now</a>
          </div>
        ),
      },
    ]

    const canAccess = hasPermission(PERMISSIONS.ICD_VIEW)
    if (canAccess) return data
    return data.filter((item) => item.id !== "actions")
  }, [hasPermission])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Signing Requests"} />

          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isCustomPageSize={true}
            // isGlobalFilter={true}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SigningRequestsWp
